import { Routes } from '@angular/router';
import { LoginComponent } from './modules/login/login.component';
import { HomeComponent } from './modules/home/home.component';
import { UsersComponent } from './modules/users/users.component';
import { UploadApoComponent } from './modules/upload-apo/upload-apo.component';
import { ProductsComponent } from './modules/products/products.component';
import { BlendersComponent } from './modules/blenders/blenders.component';
import { CleaningComponent } from './modules/cleaning/cleaning.component';
import { CleaningRulesComponent } from './modules/cleaning-rules/cleaning-rules.component';
import { PackagingMachinesComponent } from './modules/packaging-machines/packaging-machines.component';
import { PackagesComponent } from './modules/packages/packages.component';
import { MmppProductsComponent } from './modules/mmpp-products/mmpp-products.component';
import { MaterialsComponent } from './modules/materials/materials.component';
import { isLogged } from './core/guards/auth.guard';
import { JobsComponent } from './modules/jobs/jobs.component';
import { JobDetailComponent } from './modules/jobs/job-detail/job-detail.component';
import { ViewApoComponent } from './modules/view-apo/view-apo.component';
import { rolesGuard } from './core/guards/roles.guard';
import { Role } from './core/constants/roles.constants';
import { ProductMixtionComponent } from './modules/product-mixtion/product-mixtion.component';
import { CalendarComponent } from './modules/calendar/calendar.component';


export const routes: Routes = [
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
    },
    {
        path: 'login',
        component: LoginComponent
        
    },
    {
        path: 'home',
        canActivate: [isLogged],
        component: HomeComponent
    },
    {
        path: 'users',
        canActivate: [isLogged, rolesGuard],
        component: UsersComponent,
        data: { roles: [Role.Admin] }
    },
    {
        path: 'upload-apo',
        canActivate: [isLogged, rolesGuard],
        component: UploadApoComponent,
        data: { roles: [Role.Admin, Role.Planificador] }
    },
    {
        path: 'products',
        canActivate: [isLogged, rolesGuard],
        component: ProductsComponent,
        data: { roles: [Role.Admin] }
    },
    {
        path: 'blenders',
        canActivate: [isLogged, rolesGuard],
        component: BlendersComponent,
        data: { roles: [Role.Admin] }
    },
    {
        path: 'cleaning',
        canActivate: [isLogged, rolesGuard],
        component: CleaningComponent,
        data: { roles: [Role.Admin] }
    },
    {
        path: 'cleaning-rules',
        canActivate: [isLogged, rolesGuard],
        component: CleaningRulesComponent,
        data: { roles: [Role.Admin] }
    },
    {
        path: 'packaging-machines',
        canActivate: [isLogged, rolesGuard],
        component: PackagingMachinesComponent,
        data: { roles: [Role.Admin] }
    },
    {
        path: 'packages',
        canActivate: [isLogged, rolesGuard],
        component: PackagesComponent,
        data: { roles: [Role.Admin] }
    },
    {
        path: 'mmpp-products',
        canActivate: [isLogged, rolesGuard],
        component: MmppProductsComponent,
        data: { roles: [Role.Admin] }
    },
    {
        path: 'materials',
        canActivate: [isLogged, rolesGuard],
        component: MaterialsComponent,
        data: { roles: [Role.Admin] }
    },
    {
        path: 'jobs',
        canActivate: [isLogged, rolesGuard],
        component: JobsComponent,
        data: { roles: [Role.Admin] }
    },
    {
        path: 'jobs/:code',
        canActivate: [isLogged, rolesGuard],
        component: JobDetailComponent,
        data: { roles: [Role.Admin] }
    },
    {
        path: 'view-apo',
        canActivate: [isLogged, rolesGuard],
        component: ViewApoComponent,
        data: { roles: [Role.Admin, Role.Planificador] }
    },
    {
        path: 'product-mixtion',
        canActivate: [isLogged, rolesGuard],
        component: ProductMixtionComponent,
        data: { roles: [Role.Admin] }
    },
    {
        path: 'calendar',
        canActivate: [isLogged, rolesGuard],
        component: CalendarComponent,
        data: { roles: [Role.Admin] }
    }
    
];
